import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { REQUIRED_ROLES } from "@/config/authConfig";
import { useAuth } from "@/context/AuthContext";
import { Pages, UserRoleConstants } from "@/shared/Constants";
import { hasUserRole } from "@/shared/utils/roles";
import { RootState } from "@/redux/store";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAuthLoading, userRoles } = useAuth();

  // Show nothing while authentication is being checked
  if (isAuthLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  console.log("role access details:", {
    requiredRoles: REQUIRED_ROLES,
    userRoles,
  });

  // block access if user does not have at least one required role
  // if (!userRoles.some((role) => REQUIRED_ROLES.includes(role))) {
  //   return <h3>Access Denied: You do not have the required role.</h3>;
  // }

  return <>{children}</>;
};

export default ProtectedRoute;

// Admin-only route guard
export const AdminOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAuthLoading, userRoles } = useAuth();
  
  if (isAuthLoading) {
    return null;
  }
  
  if (!isAuthenticated) return <Navigate to="/" />;
  if (!hasUserRole(userRoles, UserRoleConstants.UserAdminRole)) {
    return <Navigate to={`/${Pages.dashboard}`} replace />;
  }
  return <>{children}</>;
};

// Client Profile guard: non-admin can only access self (apexId matches), admin can access any
export const ClientProfileRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAuthLoading, userRoles } = useAuth();
  const [searchParams] = useSearchParams();
  const { apexId: currentApexId } = useSelector((state: RootState) => state.auth);

  if (isAuthLoading) {
    return null;
  }

  if (!isAuthenticated) return <Navigate to="/" />;

  const apexIdParam = searchParams.get("apexId");
  const isAdmin = hasUserRole(userRoles, UserRoleConstants.UserAdminRole);

  if (!isAdmin) {
    // If apexId present and not self, redirect to dashboard
    if (apexIdParam && apexIdParam !== currentApexId) {
      return <Navigate to={`/${Pages.dashboard}`} replace />;
    }
    // If apexId missing, allow; ClientProfilePage defaults to current apexId
  }

  return <>{children}</>;
};
